import I18n from 'components/I18n'
import { actions, selectors } from 'data'
import messages from 'lang'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import CryptoOptions from '../Crypto/CryptoOptions'
import EligibilityNotifications from '../EligibilityNotifications'
import FiatModal from '../Fiat/FiatModal'
import FiatOptions from '../Fiat/FiatOptions'
import {
  Header,
  ModalCard,
  ModalTitle,
  StyledDarkTabMenuItem,
  StyledRoundedTabMenu,
  StyledSeparator
} from '../styles'
import DepositCryptoAddress from './Crypto/DepositCryptoAddress'

type Props = {
  currency?: string
}
const DepositModal = ({ currency: passedCurrency }: Props) => {
  const [currency, setCurrency] = useState<string | undefined>(passedCurrency)
  const [tab, setTab] = useState<'FIAT' | 'CRYPTO'>('FIAT')
  const dispatch = useDispatch()
  const currencies = useSelector(selectors.payments.getDepositCurrencies)
  const fiats = currencies.filter(({ type }) => type.name === 'FIAT')
  const cryptos = currencies.filter(({ type }) => type.name !== 'FIAT')
  const eligibility = useSelector(selectors.eligibility.getEligibility)

  useEffect(() => {
    dispatch(actions.account.fetchBalances())
    dispatch(
      actions.analytics.trackEvent({
        key: 'Exchange Deposit Viewed',
        properties: {
          type: tab
        }
      })
    )
  }, [tab])

  if (!currency) {
    return (
      <ModalCard>
        <Header>
          <ModalTitle>
            <I18n data={messages.deposit} />
          </ModalTitle>
        </Header>
        <StyledRoundedTabMenu>
          <StyledDarkTabMenuItem onClick={() => setTab('FIAT')} selected={tab === 'FIAT'}>
            <I18n data={messages.positions_cash} />
          </StyledDarkTabMenuItem>
          <StyledDarkTabMenuItem onClick={() => setTab('CRYPTO')} selected={tab === 'CRYPTO'}>
            <I18n data={messages.crypto} />
          </StyledDarkTabMenuItem>
        </StyledRoundedTabMenu>
        {tab === 'FIAT' && <StyledSeparator />}
        {tab === 'FIAT' &&
          (eligibility.depositFiat.enabled ? (
            <FiatOptions
              currencies={fiats}
              onItemClick={(currency) => {
                setCurrency(currency)
                dispatch(
                  actions.analytics.trackEvent({
                    key: 'Exchange Deposit Currency Selected',
                    properties: {
                      currency,
                      type: 'FIAT'
                    }
                  })
                )
              }}
            />
          ) : (
            <EligibilityNotifications
              context='DEPOSIT'
              reason={eligibility.depositFiat.reasonNotEligible}
            />
          ))}
        {tab === 'CRYPTO' &&
          (eligibility.depositCrypto.enabled ? (
            <CryptoOptions
              currencies={cryptos}
              onItemClick={(currency, query) => {
                setCurrency(currency)
                dispatch(
                  actions.analytics.trackEvent({
                    key: 'Exchange Deposit Currency Selected',
                    properties: {
                      currency,
                      search: query,
                      type: 'CRYPTO'
                    }
                  })
                )
              }}
            />
          ) : (
            <EligibilityNotifications
              context='DEPOSIT'
              reason={eligibility.depositCrypto.reasonNotEligible}
            />
          ))}
      </ModalCard>
    )
  }

  if (fiats.some((f) => f.symbol === currency)) {
    return <FiatModal currency={currency} flow='DEPOSIT' />
  }

  return <DepositCryptoAddress currency={currency} />
}

export default DepositModal
